import { sectionTypes } from '@playbooks/core/src/constants'
import { ElementKind, Fragment, Section, WidgetData } from '@playbooks/core/src/interfaces/ActionCard'

import getAllAssessments from './getAllAssessments'
import getAllWidgetElements from './getAllWidgetElements'
import { ObjectState } from './types'

/**
 * Note: This function replicates the same functionality found in:
 * LINK packages/core/src/services/ActionCardService.ts
 */
const getAvailableTags = (sections: Section[]) => {
  const conditionalTags: Record<number, string> = {}

  const relevantAssessments = getAllAssessments(sections)
  const relevantWidgets = getAllWidgetElements(sections)

  const relevantFragments = sections.flatMap<any>(sec => {
    if (sec.type === sectionTypes.CONTENT) {
      return sec.elements?.flatMap(el => {
        if (el.kind === ElementKind.RECOMMENDATION) {
          return el as Fragment
        }

        return []
      })
    }

    return []
  }) as Fragment[]

  const fragmentsTags = relevantFragments.flatMap(el => {
    const widgetTags = el.widgets?.flatMap(getTagsFromWidget)

    return (widgetTags?.length ? [...widgetTags, ...(el.setTags || [])] : el.setTags) || []
  })

  const assessmentTags = relevantAssessments.flatMap(el => {
    return el.responses.flatMap((r: any) => r.tags || [])
  })

  const widgetTags = relevantWidgets.flatMap(el => {
    const widgetElement = el as WidgetData
    return getTagsFromWidget(widgetElement)
  })

  const tags = [...assessmentTags, ...widgetTags, ...fragmentsTags]

  tags.forEach(tag => {
    conditionalTags[tag.id] = tag.name
  })

  return conditionalTags
}

function getTagsFromWidget(w: WidgetData) {
  const tagsFromStates = w.states?.flatMap((s: ObjectState) => s.activeTags || []) || []
  const res = [...tagsFromStates, ...(w.setTags || [])]

  return res
}

export default getAvailableTags
